module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/zeroHeroesExpired-b447857a1120f4b2d653a440e3afde4d.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/zeroHeroesExpired.png
// module id = 2509
// module chunks = 2